import React from 'react'
import classNames from 'classnames/bind'
import ButtonWithIcon from 'apps/ButtonWithIcon'
import * as styles from './ScrollUpButton.scss'

const cx = classNames.bind(styles)

interface IState {
  isVisible: boolean,
}

class ScrollUpButton extends React.Component<{}, IState> {
  public readonly state = {
    isVisible: false,
  }

  public componentDidMount () {
    window.addEventListener('scroll', this.onCalcVisibility)
  }

  public componentWillUnmount () {
    window.removeEventListener('scroll', this.onCalcVisibility)
  }

  private onCalcVisibility = () => {
    const { isVisible } = this.state
    if (!isVisible && window.pageYOffset > window.innerHeight) {
      this.setState({
        isVisible: true,
      })
    } else if (isVisible && window.pageYOffset <= window.innerHeight) {
      this.setState({
        isVisible: false,
      })
    }
  }

  private onScrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  public render () {
    const { isVisible } = this.state
    if (!isVisible) return null
    return (
      <div
        className={cx(
          'root',
          {
            visible: isVisible,
          },
        )}
      >
        <ButtonWithIcon
          iconName='arrowUp'
          styleType='secondary'
          onClick={this.onScrollUp}
          fluid
        />
      </div>
    )
  }
}

export default ScrollUpButton
